import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';
import { DATA_ROOM_ACCESS_INVALIDATION_KEYS } from './access-invalidation.const';
import { DataRoomAccessRow, PermissionChange } from './space.types';

type SaveVariables = { changes: PermissionChange[]; id: string };

/**
 * The Save half of Manage access: every changed permission goes in one request, so the modal
 * cannot half-apply. Row actions are the other half and have their own hook — they take effect
 * the moment they are confirmed.
 */
export const useSaveAccessPermissions = () => {
  const { invalidateQuery } = useInvalidateQueries(...DATA_ROOM_ACCESS_INVALIDATION_KEYS);

  const { isPending, mutate: savePermissions } = useAppMutation<
    DataRoomAccessRow[],
    unknown,
    SaveVariables
  >([QueryKey.SAVE_ACCESS_PERMISSIONS], {
    mutationFn: ({ id, changes }) =>
      ApiService.patch(
        { endpoint: BackendRoute.DATA_ROOMS, routePath: [id, 'access'] },
        { body: { changes } },
      ),
    onSuccess: () => {
      invalidateQuery();
    },
  });

  return { isPending, savePermissions };
};
